import React from 'react';
import { getControlStyle } from '../../../../../Components/helper';
import CommonAction from './CommonAction';
import { NewTextArea } from '../../../../../Components/PIM/common/NewTextArea';

export function SubHeading({
  label,
  placeholder,
  fromForm,
  duplicatingItem,
  gridIndex,
  pageIndex,
  disable,
  value,
  editingInput,
  showDelete,
  deleteItem,
  onChange,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  headingStyle,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
}) {
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };

  const combinedStyles = getControlStyle(otherConfiguration);

  return (
    <div>
      <NewTextArea
        name={label}
        id={label}
        disabled={disable}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value, label, gridIndex, pageIndex)}
        value={value}
        style={combinedStyles}
        className={`heading p-0 ${headingStyle?.value}`}
      />
      {fromForm && onElement && (
        <CommonAction
          editingInput={editingInput}
          gridIndex={gridIndex}
          pageIndex={pageIndex}
          showDelete={showDelete}
          deleteItem={deleteItem}
          handleDuplicateItem={handleDuplicateItem}
          supplierVisible={supplierVisible}
          handleSupplierPermission={handleSupplierPermission}
          handleStaticGrid={handleStaticGrid}
          isStatic={isStatic}
        />
      )}
    </div>
  );
}
export default SubHeading;
